import { IClient } from 'safe'
import { useForm } from 'react-hook-form'
import React, { lazy, useRef, useState } from 'react'
import { emailRegex } from '../../utils/validations'
import { useLocalStorageState } from '../../hooks/useLocalStorageState'
import { onCheckCb } from '../../utils/onCheckIfExistCb'
import { TextArea } from '../../components/Inputs/TextArea'

const Button = lazy(() => import('../../components/General/Button'));
const FieldArrayPhone = lazy(() => import('../../components/Inputs/FieldArrayPhone'));
const Form = lazy(() => import('../../components/Form'));
const FormItem = lazy(() => import('../../components/Form/FormItem'));
const InputText = lazy(() => import('../../components/Inputs/InputText'));
const Select = lazy(() => import('../../components/Inputs/Select'));

const ClientsForm: React.FC<ClientsFormProps> = ({
  defaultValues,
  id,
  onCancel,
  onSubmit,
  submitting,
  useType = 'create',
}) => {
  // const empty = '\0';
  const [typeDocumentSelected, setTypeDocumentSelected] = useState<{
    value: number | string
    text: string
  }>({
    value: 'V',
    text: 'V',
  })

  const [userConfig] = useLocalStorageState('user-config')

  const [alreadySubmitted, setAlreadySubmitted] = useState<boolean>(false)

  let inputSubmitFileRef = useRef<HTMLInputElement | null>(null)

  const [clientFile, setClientFile] = useState<File | null>(null)

  // useEffect(() => {
  //   console.log(typeDocumentSelected)
  // }, [typeDocumentSelected])

  const docs = [
    {
      value: 'V',
      text: 'V',
    },
    {
      value: 'J',
      text: 'J',
    },
    {
      value: 'E',
      text: 'E',
    },
    {
      value: 'P',
      text: 'P',
    },
    {
      value: 'G',
      text: 'G',
    },
    {
      value: 'C',
      text: 'C',
    },
  ]

  const countries = [
    {
      value: 1,
      text: '+58',
    },
    {
      value: 2,
      text: '+1',
    },
    {
      value: 3,
      text: '+57',
    },
  ]

  const getDoc = () => {
    let doc = docs.find((d) => d.value === defaultValues.documentType)
    return doc
  }

  const getPhones = () => {
    let transform = {
      '58': 1,
      '1': 2,
      '57': 3
    }
    if (defaultValues?.phone1 && defaultValues?.phone2) {
      const [country, number] = defaultValues?.phone1?.split(" ") 
      const [country2, number2] = defaultValues?.phone2?.split(" ") 
      return [{number, country: {id: transform[country] || 2 }}, {number: number2, country: {id: transform[country2] || 2 }}]
    }
    if (defaultValues?.phone1) {
      const [country, number] = defaultValues?.phone1?.split(" ") 
      return [{number, country: {id: transform[country] || 2 }}]
    }
    return []
  }

  // console.log('defaultValues: ', JSON.stringify(defaultValues, null, 2))
  const form = useForm<IClient>({
    defaultValues: {
      ...defaultValues,
      phones: getPhones(),
      document: {
        document: defaultValues?.document,
        documentType: useType === 'create' ? docs[0].value : getDoc()?.value,
      },
    },
  })

  // Required: C.I, N, A, Sector
  //

  const onSubmitImage = (e) => {
    e.preventDefault()
    if (inputSubmitFileRef.current && inputSubmitFileRef.current.files) {
      console.log("Viendo...", inputSubmitFileRef?.current.files[0])
      setClientFile(inputSubmitFileRef?.current?.files[0])
    }
  }

  return (
    <div className="m-auto">
      <h2 className="text-primary-900 font-bold dark:text-white mb-5">
        Cliente
      </h2>
      <Form
        form={form}
        classes={`gap-x-6 gap-y-2`}
        id={id}
        onSubmit={(values) => {
          let transform = {
            1: '58',
            2: '1',
            3: '57'
          }
          console.log("luis...", values)
          onSubmit({ ...values, id: defaultValues?.id, phones: values?.phones?.map(v => ({...v, country: {id: transform[v?.country?.id]}})) })
        }}
        style={{ width: '100%' }}
      >
        <FormItem
          name="document.documentType"
          defaultValue={useType === 'create' ? docs[0] : getDoc()}
          rules={{ required: 'Es necesario el campo' }}
          classes="xl:col-start-3 col-start-1 xl:col-span-2 col-span-3"
        >
          <Select
            options={docs}
            setSelectedHelper={async (v) => {
              setTypeDocumentSelected(v)
              let value = await onCheckCb(
                useType,
                form.getValues().document,
                v.value,
                userConfig.rowsPerPage,
                '/thirdparty/client?',
                'clients'
              )
              // if (value) {
              //   form?.setError('document.document', {
              //     type: 'manual',
              //     message: 'Cliente ya existe',
              //   })
              // } else {
              //   form?.clearErrors('document.document')
              // }
            }}
            label="Tipo"
          />
        </FormItem>
        <FormItem
          name="document.document"
          classes="xl:col-span-8 col-span-9"
          rules={{
            required: 'Es necesario el documento',
            pattern: { value: /^\d+$/, message: 'Documento inválido' },
            minLength: {
              value: 6,
              message: 'El documento debe de poseer al menos 6 caracteres.',
            },
          }}
        >
          <InputText isUpperValue={false}
            label="Documento"
            maxLength={10}
            onCheckIfExist={async () => {
              console.log('in...')
              let value = await onCheckCb(
                useType,
                form.getValues().document,
                form.getValues().documentType,
                userConfig.rowsPerPage,
                '/thirdparty/client?',
                'clients'
              )
              // if (value) {
              //   form?.setError('document.document', {
              //     type: 'manual',
              //     message: 'Cliente ya existe',
              //   })
              // } else {
              //   form?.clearErrors('document.document')
              // }
            }}
          />
        </FormItem>

        {typeDocumentSelected.value === 'J' ||
        typeDocumentSelected.value === 'C' ? (
          <FormItem
            name="name"
            classes="xl:col-start-3 xl:col-span-10 col-span-12"
            rules={{ required: 'El campo nombre es requerido' }}
          >
            <InputText small label="Razón Social" maxLength={100} isUpperValue={false} />
          </FormItem>
        ) : (
          <>
            <FormItem
              name="name"
              classes="xl:col-start-3 xl:col-span-10 lg:col-span-12"
              rules={{ required: 'El campo nombre es requerido' }}
            >
              <InputText small label="Nombre" maxLength={100} isUpperValue={false} />
            </FormItem>

            {/* <FormItem
              name="surname"
              classes="xl:col-span-5 col-span-6"
              rules={{ required: 'El campo apellido es requerido' }}
            >
              <InputText small label="Apellidos" maxLength={100} />
            </FormItem> */}
          </>
        )}

        <FormItem
          name="email"
          classes="xl:col-start-3 xl:col-span-10 col-span-12"
          rules={{
            pattern: {
              value: emailRegex,
              message: 'El email ingresado debe ser válido',
            },
          }}
        >
          <InputText
            small
            label="Correo Electrónico"
            maxLength={255}
            isUpperValue={false}
          />
        </FormItem>

        {/* <div className="col-start-4 xl:col-span-12 col-span-12 mt-3 mb-3">
          <div className="flex justify-between items-center">
            <Button
              type="primary"
              loading={submitting}
              classes=""
              onClick={() =>
                inputSubmitFileRef.current && inputSubmitFileRef.current.click()
              }
            >
              Subir documento
            </Button>

            <input
              type="file"
              ref={inputSubmitFileRef}
              onChange={onSubmitImage}
            />
          </div>
        </div> */}

        <h2 className="xl:col-span-2 mt-1 text-primary-900 font-bold dark:text-white lg:col-span-12">
          Dirección
        </h2>

        {/* <FormItem
          name="address.street"
          classes="xl:col-start-3 xl:col-span-5 col-start-1 col-span-6"
          // rules={{ required: 'Es necesaria ingresar la calle' }}
        >
          <InputText small label="Calle" maxLength={50} />
        </FormItem>

        <FormItem
          name="address.neighborhood"
          classes="xl:col-span-5 col-span-6"
          // rules={{ required: 'Es necesaria ingresar el sector' }}
        >
          <InputText small label="Sector" maxLength={50} />
        </FormItem>

        <FormItem
          name="address.avenue"
          classes="xl:col-start-3 xl:col-span-5 col-span-6"
          // rules={{ required: 'Es necesaria ingresar la avenida' }}
        >
          <InputText small label="Avenida" maxLength={50} />
        </FormItem>

        <FormItem
          name="address.building"
          classes="xl:col-span-5 col-span-6"
          // rules={{ required: 'Es necesaria ingresar una dirección de casa o edificio' }}
        >
          <InputText small label="Casa / Edificio" maxLength={50} />
        </FormItem> */}

        <FormItem
          name="address.address"
          classes="xl:col-start-3 xl:col-span-10 col-span-12 lg:col-span-12"
          rules={{ required: 'Es necesario ingresar la dirección fiscal' }}
        >
          <TextArea
            label="Dirección"
            placeholder="Ingresar dirección exacta del RIF"
            maxLength={255}
            isUpperValue={false}
          />
        </FormItem>


        <FormItem
          name="address.country"
          classes="xl:col-start-3 xl:col-span-5 col-span-6"
          defaultValue={userConfig?.default?.country}
          rules={{ required: 'Es necesario ingresar el país' }}
        >
          <InputText isUpperValue={false} small label="País" maxLength={50} />
        </FormItem>

        <FormItem
          name="address.city"
          classes="xl:col-span-5 col-span-6"
          rules={{ required: 'Es necesario la ciudad' }}
          defaultValue={userConfig?.default?.city}
        >
          <InputText isUpperValue={false} small label="Ciudad" maxLength={50} />
        </FormItem>

        <FormItem
          name="address.state"
          classes="xl:col-start-3 xl:col-span-5 col-span-6"
          rules={{ required: 'Es necesario el estado' }}
          defaultValue={userConfig?.default?.province}
        >
          <InputText isUpperValue={false} small label="Estado" maxLength={50} />
        </FormItem>

        <FormItem
          name="address.postalCode"
          classes="xl:col-span-5 col-span-6"
          rules={{ required: 'Es necesario ingresar un codigo postal' }}
          defaultValue={userConfig?.default?.PC}
        >
          <InputText isUpperValue={false} small label="Código Postal" maxLength={10} />
        </FormItem>

        <h2 className="col-start-1 mt-1 col-span-2 text-primary-900 font-bold dark:text-white">
          Teléfonos
        </h2>
        <FieldArrayPhone name="phones" fieldLength={2}>
          <FormItem
            name="country.id"
            rules={{ required: 'Es necesario el campo' }}
            classes="xl:col-start-3 xl:col-span-2 col-start-1 col-span-4"
            defaultValue={useType === 'create' ? countries[0] : getPhones()}
          >
            <Select
              options={countries}
              label="Código"
            />
          </FormItem>
          <FormItem
            name="number"
            classes="xl:col-span-7 col-span-7"
            rules={{
              pattern: { value: /^\d+$/, message: 'Campo de tipo númerico' },
            }}
            alreadySubmitted={alreadySubmitted}
          >
            <InputText isUpperValue={false} phone={true} small label="Teléfono" maxLength={15} />
          </FormItem>
        </FieldArrayPhone>

        {/* <FormItem name="address.id" classes="xl:col-span-4 col-span-12">
          <InputText small label="address.id" hidden />
        </FormItem> */}

        {/* <FormItem name="address.type">
          <InputText label="type" value="common" hidden />
        </FormItem> */}

        {/* <FormItem name="address.headquarters">
          <InputText label="headquarters" value="headquarters" hidden />
        </FormItem> */}

        <div className="col-span-12 h-full flex flex-row">
          <div className="w-1/2 mr-5 pl-1">
            <Button
              onClick={() => {
                if (onCancel) onCancel()
              }}
              type="outline"
              loading={submitting}
              classes="w-full"
            >
              Cancelar
            </Button>
          </div>
          <div className="w-1/2 pr-1">
            <Button
              type="primary"
              loading={submitting}
              classes="w-full"
              htmlType="submit"
              onClick={() => setAlreadySubmitted(true)}
            >
              {useType === 'create' ? 'Añadir' : 'Guardar cambios'}
            </Button>
          </div>
        </div>
      </Form>
    </div>
  )
}

export default ClientsForm

interface ClientsFormProps {
  defaultValues?: object | any
  id?: string
  onCancel?: Function
  onDelete?: Function
  onSubmit: Function
  submitting?: boolean
  useType?: 'create' | 'edit'
  preloadedData?: object | any
}
